// La caja general por mes: el saldo que arrastra cada mes es el del último mes con movimientos hasta él.

export interface MesDeCaja {
  /** Primer día del mes, AAAA-MM-01. */
  mes: string;
  ingresos: number;
  gastos: number;
  utilidad: number;
  saldo: number;
}

/** El saldo al cierre de `mes`, o `null` si ningún mes hasta ese tuvo movimientos. `meses` va en orden. */
export function saldoAlCierre(meses: MesDeCaja[], mes: string): number | null {
  let saldo: number | null = null;
  for (const m of meses) {
    if (m.mes > mes) break;
    saldo = m.saldo;
  }
  return saldo;
}
